<div class="template-setting">
  <div class="ui-g pt-4 pb-4">
    <div class="template-sidebar p-0">
      <app-tertiary-navbar [navItems]="navItems" defaultActiveItemId="users"
      ></app-tertiary-navbar>
    </div>
    <div class="template-content tertiary-content">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
